import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "@context/AuthContext";
import { SearchContext } from "@context/SearchContext";
import PlusIcon from "@components/Icons/PlusIcon";
import Button from "@components/Ui/Button";
import Drawer from "@components/V3/Drawer";
import ExperienceItems from "@components/V3/ExperienceSelector/ExperienceItems";
import "./style.scss";

const ExperienceFinder = ({ handleExperienceClick }) => {
    const { drawerState, openDrawer, closeDrawer } = useContext(AuthContext);
    const { selectedExperiences, availableClasses } = useContext(SearchContext);
    const [pendingSelections, setPendingSelections] = useState(selectedExperiences);

    useEffect(() => {
        if (drawerState.experienceDrawer) {
            setPendingSelections(selectedExperiences);
        }
    }, [drawerState.experienceDrawer]);

    const handleFinishSelection = () => {
        handleExperienceClick(pendingSelections);
        closeDrawer("experienceDrawer");
    };

    const closeWithoutSaving = () => {
        closeDrawer("experienceDrawer");
    };            

    const selectedShortNames = availableClasses.reduce((array, exp) => {
        if (selectedExperiences.includes(exp.id)) array.push(exp.short_name);
        return array;
    }, []);

    return (
        <div className="experience-finder">
            <Button
                additionalClasses="experience-finder__button"
                onClick={() => openDrawer("experienceDrawer")}
                aria-label={`Select movie experience. Current selection: ${selectedShortNames.length > 0 ? selectedShortNames.join(", ") : "None"}`}
                aria-expanded={drawerState.experienceDrawer}
                aria-controls="experience-drawer"
            >
                {selectedShortNames.length > 0 ? selectedShortNames.join(", ") : "Select Experience"}
                <PlusIcon className="experience-finder__icon" />
            </Button>

            {drawerState.experienceDrawer && (
                <Drawer
                    id="experience-drawer"
                    aria-label="Experience Selection"
                    isOpen={drawerState.experienceDrawer}
                    onClose={closeWithoutSaving}
                    closeButtonAlignment="right"
                >
                    <ExperienceItems
                        handleExperienceClick={setPendingSelections}
                        selectedExperiences={pendingSelections}
                        selectedShortNames={selectedShortNames}
                    />
                    <Button
                        aria-label="Save experience selection and close"
                        additionalClasses="button button__primary"
                        onClick={handleFinishSelection}
                    >
                        Save and browse
                    </Button>
                </Drawer>
            )}
        </div>
    );
};

export default ExperienceFinder;
